export const fmt4 = (v) =>
  v === null || v === undefined || v === "" ? "" : Number(v).toFixed(4);

export const fmt2 = (v) =>
  v === null || v === undefined || v === "" ? "" : Number(v).toFixed(2);

export function formatQty2(v) {
  if (v === null || v === undefined || v === "") return "";
  return Number(v).toFixed(2);
}
export function formatQty4(v) {
  if (v === null || v === undefined || v === "") return "";
  return Number(v).toFixed(4);
}

export function format4(v) {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n.toFixed(4) : "";
}

export function format2(v) {
  if (v === null || v === undefined || v === "") return "";
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n.toFixed(2) : "";
}

export const parseDec = (s) => {
  const v = Number(String(s).replace(",", "."));
  return Number.isFinite(v) ? v : null;
};
